import { Text, View } from '@react-pdf/renderer';

const PersonalInfo = ({
	styles,
	data: { countryCode = '', phoneNumber = '', email = '', website = '', address = '' },
}: any) => {
	return (
		<View style={styles.mainBox}>
			<View>
				{(countryCode || phoneNumber) && (
					<View style={styles.personalContent}>
						<View style={styles.listBorder}>
							<View style={styles.listCircle}></View>
						</View>
						<View>
							<Text style={styles.personalDataTitle}>Phone no.</Text>
							<Text style={styles.personalData}>
								+({countryCode}) {phoneNumber}
							</Text>
						</View>
					</View>
				)}

				{email && (
					<View style={styles.personalContent}>
						<View style={styles.listBorder}>
							<View style={styles.listCircle}></View>
						</View>
						<View>
							<Text style={styles.personalDataTitle}>EMAIL</Text>
							<Text style={styles.personalData}>{email}</Text>
						</View>
					</View>
				)}

				{website && (
					<View style={styles.personalContent}>
						<View style={styles.listBorder}>
							<View style={styles.listCircle}></View>
						</View>
						<View>
							<Text style={styles.personalDataTitle}>WEBSITE</Text>
							<Text style={styles.personalData}>{website}</Text>
						</View>
					</View>
				)}

				{address && (
					<View style={styles.personalContent}>
						<View style={styles.listBorder}>
							<View style={styles.listCircle}></View>
						</View>
						<View>
							<Text style={styles.personalDataTitle}>ADDRESS</Text>
							<Text style={styles.personalData}>{address}</Text>
						</View>
					</View>
				)}
			</View>
		</View>
	);
};

export default PersonalInfo;
